import React, { useEffect, useState } from 'react';
import { Menu } from '../_Menu';
import Pagger from '../components/_Pagger';
import Header from '../Header';
import { Popover, Select } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMagnifyingGlass, faWrench } from '@fortawesome/free-solid-svg-icons';
import { CustomerCardModel } from '../models/CustomerCardModel';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { SimulatorModel } from '../models/SimulatorModel';
import ClientTreatmentConfigPopup from '../clients/_ClientTreatmentConfigPopup';
import SigningTable from './_SigningTable';
import { LeadDocumentPopup } from '../leads/_LeadDocumentPopup';
import { ViewMode } from '../clients/enums';
import SigningDetails from './_SigningDetails';
import AdvancedSigningSearch from './_AdvancedSigningSearch';
import { OfferProductionModel } from '../models/OfferProductionModel';
import SigningConfigPopup from './_SigningConfigPopup';
import TasksAddTaskPopup from '../tasks/_TasksAddTaskPopup';
import { SubscriberPopup } from '../subscribers/_SubscriberPopup';
import { SubscriberPopupForSigning } from '../subscribers/popups/_SubscriberPopupForSigning';
import { SubscriberUpdatePaymentPopup } from '../subscribers/popups/_UpdatePaymentsPopup';

import { ElementaryPolicyStatusModel } from '../models/ElementaryPolicyStatus';
import { GeneralDataModel } from '../models/GeneralDataModel';
import AssignToHandlerPopUp from './_AssignToHandlerPopUp';
import { SigningModel } from '../models/SigningModel';
import { SubscribersModel } from '../models/SubscribersModel';
import { RiderModel, TreatmentType } from '../models/superbit-api-models';
import ClientAddTreatmentPopup from '../clients/_ClientAddTreatmentPopup';
import { RootState } from '../app-context/store';
import SignMessagePopUp from './_SignMessagePopUp';
import EditHandlerTreatment from '../tasks/_EditHandlerTreatment';
import { setHandlerTreatmentPopUp, setSigningData, setSigningRidersData } from '../app-context/signsSlice';
import { set } from 'lodash';


const productionTypes = [
    {
        label: 'בחר סוג הפקה',
        value: '-1'
    },
    {
        label: 'ידנית',
        value: '0'
    },
    {
        label: 'אוטומטית',
        value: '1'
    }]

const Signing = () => {
    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    const generalModel: GeneralDataModel = new GeneralDataModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const offerProductionModel: OfferProductionModel = new OfferProductionModel();
    const elementaryPolicyStatusModel: ElementaryPolicyStatusModel = new ElementaryPolicyStatusModel();
    const signingModel = new SigningModel();
    const dispatch = useDispatch();

    const userLogged = useSelector((state: any) => state.user.value);
    const [signingFilter, setSigningFilter] = useState<any>({
        page: 1
    });
    const popUpTreatmentSignsModel = useSelector((state: RootState) => state.signs.popUpTreatmentSuesModel);
    const handlerTreatmentPopUp = useSelector((state: RootState) => state.signs.handlerTreatmentPopUp);
    const signingData = useSelector((state: RootState) => state.signs.signingData);
    const signingRiderData = useSelector((state: RootState) => state.signs.signingRidersData);

    const [copyFromLastFilter, setCopyFromLastFilter] = useState<boolean>(false);

    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
    const [riderToEdit, setRiderToEdit] = useState<RiderModel | null>(null);
    const [riderToPayment, setRiderToPayment] = useState<RiderModel | null>(null);
    const [popupShow, setPopupShow] = useState<boolean>(false);
    const [goToPayment, setGoToPayment] = useState<boolean>(false);
    const [message, setMessege] = useState<string>('');
    const [messageType, setMessageType] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [loadTreatments, setLoadTreatments] = useState<number>(0);
    const [documentUrl, setDocumentUrl] = useState<string | null>(null);
    const [openTabs, setOpenTabs] = useState<any[]>([]);
    const [sellectedSigningId, setSellectedSigningId] = useState<string | null>(null);
    const [selectedTabData, setSelectedTabData] = useState<any | null>(null);
    const [showOnlyRiders, setShowOnlyRiders] = useState<boolean>(false);
    const [showOnlyOpens, setShowOnlyOpens] = useState<boolean>(false);
    const [pageLoaded, setPageLoaded] = useState<boolean>(false);

    const [currentUser, setCurrentUser] = useState<any | null>();

    const [creatorsOptions, setCreatorsOptions] = useState<any[]>([]);
    const [creatorsList, setCreatorsList] = useState<any[]>([]);
    const [handlersOptions, setHandlersOptions] = useState<any[]>([]);

    const [signingList, setSigningList] = useState<any[] | null>([]);
    const [signingRiderList, setSigningRiderList] = useState<any[] | null>([]);

    const [sortBy, setSortBy] = useState<any | undefined>(undefined);
    const [searchText, setSearchText] = useState<string>('');
    const [treatmentsTimeoutId, setTreatmentsTimeoutId] = useState<number | any | null>(undefined);

    const [showAddTreatmentPopUp, setShowAddTreatmentPopup] = useState<boolean>(false);
    const [showAddSubscriberPopUp, setShowAddSubscriberPopup] = useState<boolean>(false);
    const [showAssignToHandlerPopUp, setShowAssignToHandlerPopUp] = useState<boolean>(false);
    const [signingIdToAssign, setSigningIdToAssign] = useState<string | null>(null)
    const [selectedAssigment, setSelectedAssigment] = useState<any | null>(null)
    const [policyId, setPolicyId] = useState<any | null>(null)
    const [customerId, setCustomerId] = useState<any | null>(null)
    const [selectedCustomer, setSelectedCustomer] = useState<any | null>(null)
    const [selectedVehicle, setSelectedVehicle] = useState<any | null>(null)
    const [showSigningConfigPopUp, setShowSigningConfigPopup] = useState<boolean>(false);
    const [treatmentType, setTreatmentType] = useState<number>(0);

    const [assigmentStatuses, setAssignmentStatuses] = useState<any[]>([]);
    const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);
    const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState<string>('');

    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [agents, setAgents] = useState<any[]>([])
    const [selectedAgent, setSelectedAgent] = useState<string>('0');
    const [selectedDateParam, setSelectedDateParam] = useState<string>('0');

    const [insuranceTypes, setInsuranceTypes] = useState<any[]>([]);
    const [vehicleOwnerships, setVehicleOwnership] = useState<any[]>([]);
    const [policyTypes, setPolicyTypes] = useState<any[]>([]);

    const [riderStatuses, setRiderStatuses] = useState<any[]>([]);


    const [currentPage, setCurrentPage] = useState<number>(1);

    const [filterCount, setFilterCount] = useState<string>('');
    const [selectedFilterOptions, setSelectedFilterOptions] = useState<any[]>([]);

    const [gendersList, setGendersList] = useState<any[]>([]);
    const [policyStatuses, setPolicyStatuses] = useState<any[]>([]);
    const [usersList, setUsersList] = useState<any[]>([]);
    const [pagerConf, setPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    const [roleId, setRoleId] = useState<boolean>(false)
    const [isActionBtns, setIsActionBtns] = useState<boolean>(true)

    const [showPopUpMessage, setShowPopUpMessage] = useState<boolean>(false);
    const [popUpTitle, setPopUpTitle] = useState<string>('');

    const [loadData, setLoadData] = useState<boolean>(false);


    const init = () => {
        setCopyFromLastFilter(true);
        loadScreenMode();

        getComboData();
    }

    useEffect(() => {
        console.log('sellectedSigningId-changed', sellectedSigningId);
        saveScreenMode();

    }, [sellectedSigningId !== null]);

    useEffect(() => {
        if (popUpTreatmentSignsModel.show) {
            setTreatmentType(popUpTreatmentSignsModel.type);
            setShowAddTreatmentPopup(popUpTreatmentSignsModel.show);
        }

    }, [popUpTreatmentSignsModel])

    const saveScreenMode = (filter?: any) => {
        console.log('sellectedSigningId-changed', sellectedSigningId, copyFromLastFilter, pageLoaded);

        if (copyFromLastFilter) {
            setCopyFromLastFilter(false);
            const signingPageData = sessionStorage.getItem('signingPageData');
            if (signingPageData) {
                const data = JSON.parse(signingPageData);
                console.log('saveScreenMode-data.openTabs', data.openTabs)
                setSigningFilter(data.signingFilter);
                setSortBy(data.sortBy);
                setCurrentPage(data.currentPage);
                setPagerConf(data.pagerConf);
                setSearchText(data.searchText);
                setOpenTabs(data.openTabs);
                setSellectedSigningId(data.sellectedSigningId);
                setSelectedTabData(data.selectedTabData);
            }
        } else {

            console.log('saveScreenMode', openTabs)
            if (pageLoaded) {
                var signingPageData = {
                    "signingFilter": filter ? filter : signingFilter,
                    "sortBy": sortBy,
                    "currentPage": currentPage,
                    "pagerConf": pagerConf,
                    "searchText": searchText,
                    "openTabs": openTabs,
                    "sellectedSigningId": sellectedSigningId,
                    "selectedTabData": selectedTabData
                };
                console.log('saveScreenMode-signingPageData', signingPageData)

                sessionStorage.setItem('signingPageData', JSON.stringify(signingPageData));
            }
        }
    }
    const loadScreenMode = async () => {
        const signingPageData = sessionStorage.getItem('signingPageData');
        if (signingPageData) {
            var data = JSON.parse(signingPageData);
            await setSigningFilter(data.signingFilter);
            await setSortBy(data.sortBy);
            await setCurrentPage(data.currentPage);
            await setPagerConf(data.pagerConf);
            await setSearchText(data.searchText);
            await setOpenTabs(data.openTabs);
            await setSellectedSigningId(data.sellectedSigningId);
            await setSelectedTabData(data.selectedTabData);

        }
        await setPageLoaded(true);
    }



    const getComboData = async () => {
        // const assigmentStatusesData = await customerCardModel.getAssignmentStatuses();
        // setAssignmentStatuses(assigmentStatusesData.map((s: any) => {
        //     return {
        //         label: s.name,
        //         value: s.id
        //     }
        // }))

        const insuranceTypesList: any[] = [];
        const insuranceTypesData = await generalModel.getAppDictionaryListExpanded();
        const itTempDataKeys = Object.keys(insuranceTypesData);
        itTempDataKeys.forEach((k: string) => {
            insuranceTypesList.push({
                value: insuranceTypesData[k].id,
                label: insuranceTypesData[k].description,
                id: insuranceTypesData[k].id,
                name: insuranceTypesData[k].description,
            })
        });
        setInsuranceTypes(insuranceTypesList);


        let _handlersList: any[] = [];
        const handlersListStorage = localStorage.getItem('usersList');
        if (handlersListStorage) {
            _handlersList = JSON.parse(handlersListStorage);
            const activeHandlerList = _handlersList.filter((h: any) => h.status == 0
                && (h.roleId == "4a0a7e1b-7e16-4134-b8b7-de6ef7ad2aec" || h.roleId == "e026af6f-52f0-40b6-b12f-94c546da1725"
                    || h.branchId == "f65ba4e2-8fae-49da-b351-e288a9459f21" || h.branchId == "3b729183-d7a4-49a6-911e-35b63eb0c438"));
            setUsersList(activeHandlerList.map((u: any, i: number) => {
                return {
                    value: u.id,
                    label: u.fullName
                }
            }));
        } else {
            setUsersList([]);
        }


        const riderStatusesList: any[] = [];
        const riderStatusesData = await generalModel.getRiderStatuses();
        const riderStatusesTempDataKeys = Object.keys(riderStatusesData);
        riderStatusesTempDataKeys.forEach((k: string) => {
            const item = {
                id: riderStatusesData[k].id,
                name: riderStatusesData[k].description,
                nameEng: riderStatusesData[k].name,
            };
            console.log('item', item);
            riderStatusesList.push(item);
        });
        setRiderStatuses(riderStatusesList);

        const vehicleOwnershipList: any[] = [];
        const vehicleOwnershipData = await simulatorModel.getVehicleOwnership();
        const sTempDataKeys = Object.keys(vehicleOwnershipData);
        sTempDataKeys.forEach((k: string) => {
            vehicleOwnershipList.push({
                value: vehicleOwnershipData[k].id,
                label: vehicleOwnershipData[k].description,
                id: vehicleOwnershipData[k].id,
                name: vehicleOwnershipData[k].description,
            })
        });
        setVehicleOwnership(vehicleOwnershipList)

        const policyTypesList: any[] = [];
        const policyTypesData = await simulatorModel.getPolicyTypes();
        const pTempDataKeys = Object.keys(policyTypesData);
        pTempDataKeys.forEach((k: string) => {
            if (k !== '0') {
                policyTypesList.push({
                    value: policyTypesData[k].id.toString(),
                    label: policyTypesData[k].description,
                    id: policyTypesData[k].id.toString(),
                    name: policyTypesData[k].description,
                });
            }
        });
        setPolicyTypes(policyTypesList);

        const creatorsList = localStorage.getItem('creatorsList');
        if (creatorsList) {
            const dataList = buildOptionsForSelect(JSON.parse(creatorsList), 'id', 'כל היוצרים');
            setCreatorsOptions(dataList)
            // const source = JSON.parse(creatorsList);
            const newCreatorsList: any = [
                {
                    label: 'נוצר ע"י',
                    value: '-1'
                },
                {
                    label: 'יוזרים פעילים',
                    value: '0'
                },
                {
                    label: 'יוזרים לא פעילים',
                    value: '1'
                },
                {
                    label: 'כל היוזרים',
                    value: '2'
                },
                ...dataList
            ]
            setCreatorsList(newCreatorsList)
        }
        const handlersList = localStorage.getItem('handlersList');
        if (handlersList) {
            const hList = [{
                label: 'יוזרים פעילים',
                value: '0'
            },
            {
                label: 'יוזרים לא פעילים',
                value: '1'
            },
            {
                label: 'כל היוזרים',
                value: '2'
            },]
            setHandlersOptions([
                ...hList,
                ...buildOptionsForSelect(JSON.parse(handlersList), 'id', 'כל מטפלים')
            ])
        }
        const agentsData = await simulatorModel.getCustomerCardAgents();
        await setAgents(agentsData);
        await setAgentsList(agentsData.map((a: any) => {
            return {
                value: a.id,
                label: a.name
            }
        }))
        const gendersData = await simulatorModel.getGenderTypes();
        const genders: any = [];
        Object.keys(gendersData).forEach((key: string) => {
            const gender = gendersData[key];
            genders.push({
                label: gender.description,
                value: gender.id.toString()
            })
        })
        setGendersList(genders);

        const policyStatusesData = await offerProductionModel.getPolicyStatuses();
        setPolicyStatuses(policyStatusesData.map((ps: any) => {
            return {
                label: ps.name,
                value: ps.id.toString()
            }
        }))


        try {
            const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
            const icTempDataKeys = Object.keys(insuranceCompaniesData);
            const fixedInsuranceCompanies: any[] = [];
            icTempDataKeys.forEach((k: string) => {
                fixedInsuranceCompanies.push({
                    value: insuranceCompaniesData[k].description,
                    label: insuranceCompaniesData[k].name,
                    id: insuranceCompaniesData[k].description,
                    name: insuranceCompaniesData[k].name,
                })
            });
            fixedInsuranceCompanies.sort((a: any, b: any) => (a.label > b.label) ? 1 : -1)
            // data.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1);
            setInsuranceCompanyList(fixedInsuranceCompanies);
        } catch (error) {
            console.error('Error fetching insurance companies:', error);
        } finally {
            setLoadData(true);
        }
        // getSignings();

        let loggedUserData: any = localStorage.getItem('loggedUser');
        if (loggedUserData) {
            let loggedUser = JSON.parse(loggedUserData);
            setRoleId(loggedUser.role);
            const filter = signingFilter;
            if (loggedUser && (loggedUser.role == 8 /*|| loggedUser.role == 6*/)) {
                //const filter = signingFilter;
                filter.underwriterType = 3; //specific usr
                filter.underwriterUserId = loggedUser.id;
            }
            if (loggedUser && (loggedUser.role == 6 || loggedUser.role == 13 || loggedUser.role == 14)) {
                setIsActionBtns(false);
            }

            if (loggedUser && (loggedUser.role != 0) && !filter.ElementaryPolicyStatusId) {

                filter.openPolicies = true;
            }
            setSigningFilter(filter);
        }
        // if (currentUser) {
        //     console.log('userLogged', currentUser)
        // }

    }

    const setRiderToPopup = async (rider: RiderModel) => {
        const model = await new SubscribersModel().upsertRider({
            id: rider.id,
            actionType: 5
        });
        setRiderToEdit(model);
    }

    const onUpdatePaymentsClick = async (rider: RiderModel) => {
        const model = await new SubscribersModel().upsertRider({
            id: rider.id,
            actionType: 5
        });
        setRiderToPayment(model);
    }

    const onActivateRiderClick = async (riderId: string) => {
        const model = await new SubscribersModel().riderActivateRider(riderId);
        const _model = await new SubscribersModel().upsertRider({
            id: riderId,
            actionType: 5
        });
        setRiderToPayment(_model);
    }



    const getSigningsInitilaize = async (filter?: any) => {
        console.log('signingFilter', filter)


        setLoading(true);
        setSigningList([]);
        if (!filter) {
            filter = signingFilter;
        }
        if (sortBy && !filter.sortBy) {
            filter.sortBy = [sortBy];
        }

        const filterKeys = Object.keys(filter);
        const filterParams: any[] = [];


        filterKeys.forEach((key: string) => {
            if (filter[key] == undefined && key !== 'ElementaryPolicyStatusId') return;
            const filterOption: any = {
                key: key,
                label: ''
            }
            let include = false;
            switch (key) {
                case 'openPolicies': {
                    if (filter[key]) {
                        filterOption.label = 'סטטוס';
                        const selected = creatorsList.find((a: any) => a.value == filter.creatorUserId);
                        filterOption.value = "כל הפתוחים";
                        include = true;
                    }
                    break;
                }
                case 'creatorUserId': {
                    filterOption.label = 'נוצר ע"י';
                    const selected = creatorsList.find((a: any) => a.value == filter.creatorUserId);
                    if (selected) {
                        filterOption.value = selected.label;
                    }
                    include = true;
                    break;
                }
                case 'productionType': {
                    filterOption.label = 'סוג הפקה';
                    const selected = productionTypes.find((a: any) => a.value == filter.productionType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'leadSource': {
                    filterOption.label = 'סוג הפקה';
                    const options = [
                        {
                            label: 'חדש',
                            value: '0'
                        },
                        {
                            label: 'חידוש',
                            value: '1'
                        }
                    ];
                    const selected = options.find((o: any) => o.value == filter.leadSource);
                    if (selected) {
                        include = true;
                        filterOption.value = selected.label;
                    }
                    break;
                }
                case 'ElementaryPolicyStatusId': {
                    filterOption.label = 'סטטוס';
                    const selected: any = policyStatuses.find((ps: any) => ps.value == filter.ElementaryPolicyStatusId);
                    if (selected) {
                        include = true;
                        filterOption.value = selected.label;
                    }
                    break;
                }
                case 'underwriterUserId': {
                    filterOption.label = 'מטפל';
                    const selected = creatorsList.find((a: any) => a.value == filter.underwriterUserId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'insuranceCompanyId': {
                    filterOption.label = 'חברת ביטוח';
                    if (filter.insuranceCompanyId === '-1') {
                        filterOption.value = 'פלוס שירותי דרך';
                        include = true;
                    } else {
                        const selected = insuranceCompanyList.find((a: any) => a.value == filter.insuranceCompanyId);
                        if (selected) {
                            filterOption.value = selected.label;
                            include = true;
                        }
                    }
                    break;
                }
                case 'insuranceCompanyRouteId':
                    filterOption.label = 'מסלול';
                    filterOption.value = filter.insuranceCompanyRouteLabel;
                    include = true;
                    break;
                case 'agentId': {
                    filterOption.label = 'סוכן';
                    const selected = agentsList.find((a: any) => a.value == filter.agentId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'createdDateFrom': {
                    filterOption.label = 'ת. יצירה מ';
                    filterOption.value = moment(filter.createdDateFrom).format('DD-MM-YYYY');
                    include = true;
                    break;
                }
                case 'createdDateTo':
                    filterOption.label = 'ת. יצירה עד';
                    filterOption.value = moment(filter.createdDateTo).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'startDateFrom':
                    filterOption.label = 'יעד סיום מ';
                    filterOption.value = moment(filter.startDateFrom).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'startDateTo':
                    filterOption.label = 'יעד סיום עד';
                    filterOption.value = moment(filter.startDateTo).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'policyType': {
                    filterOption.label = 'סוג הפוליסה';
                    const selected = policyTypes.find((a: any) => a.value == filter.policyType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'insuranceType': {
                    filterOption.label = 'סוג הביטוח';
                    const selected = insuranceTypes.find((a: any) => a.value == filter.insuranceType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                // case 'productionStep':
                //     filterOption.label = 'הפקה';
                //     include = filterOption.value = filter.productionStep;
                //     break;
                // case 'collectionStep':
                //     filterOption.label = 'גביה';
                //     include = filterOption.value = filter.collectionStep;
                //     break;
                // case 'protectionStep':
                //     filterOption.label = 'מיגון';
                //     include = filterOption.value = filter.protectionStep;
                //     break;
                // case 'lackOfClaimsStep':
                //     filterOption.label = 'ה. תביעות';
                //     include = filterOption.value = filter.lackOfClaimsStep;
                //     break;
                // case 'documentsStep':
                //     filterOption.label = 'מסמכים';
                //     include = filterOption.value = filter.documentsStep;
                //     break;
                // case 'sendingToCustomerStep':
                //     filterOption.label = 'שליחה';
                //     include = filterOption.value = filter.sendingToCustomerStep;
                //     break;
                case 'collectionStep':
                    filterOption.label = 'גביה';
                    if (filter.collectionStep != null && filter.collectionStep != undefined) {
                        filterOption.value = filter.collectionStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'protectionStep':
                    filterOption.label = 'מיגון';
                    if (filter.protectionStep != null && filter.protectionStep != undefined) {
                        filterOption.value = filter.protectionStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'lackOfClaimsStep':
                    filterOption.label = 'ה. תביעות';
                    if (filter.lackOfClaimsStep != null && filter.lackOfClaimsStep != undefined) {
                        filterOption.value = filter.lackOfClaimsStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'documentsStep':
                    filterOption.label = 'מסמכים';
                    if (filter.documentsStep != null && filter.documentsStep != undefined) {
                        filterOption.value = filter.documentsStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'sendingToCustomerStep':
                    filterOption.label = 'שליחה';
                    if (filter.sendingToCustomerStep != null && filter.sendingToCustomerStep != undefined) {
                        filterOption.value = filter.sendingToCustomerStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                default:
                    break;
            }

            if (include && filterOption.value !== undefined) {
                filterParams.push(filterOption)
            }
            console.log('filterParams', key, filter[key], filterParams);
        });
        setSelectedFilterOptions(filterParams)
        setFilterCount(filterParams.length.toString());

        // setShowOnlyRiders(false);
        if (filter.insuranceCompanyId < 0) {
            filter.insuranceCompanyId = undefined;
            setShowOnlyRiders(true);
        } else {
            setShowOnlyRiders(false);
        }
        setSigningList([]);
        setSigningRiderList([]);
        if ((signingData && signingData.length > 0) || (signingRiderData && signingRiderData.length > 0)) {
            if (signingData && signingData.length > 0) {
                setSigningList([...signingData]);
                setPagerConf({
                    ...pagerConf,
                    totalItems: signingData.length
                });
            }
            if (signingRiderData && signingRiderData.length > 0) {
                setSigningRiderList([...signingRiderData]);
                setPagerConf({
                    ...pagerConf,
                    totalItems: signingRiderData.length
                });
            }
            setLoading(false);
            return;
        }
        const signingsData = await signingModel.signingFilter(filter);
        console.log('signingsData-init', signingsData)
        if (signingsData) {
            if (signingsData.signings && signingsData.signings.length && insuranceCompanyList.length > 0) {
                const newConf = pagerConf;
                newConf.totalItems = signingsData.counter;
                setPagerConf(newConf);
                setSigningList([...signingsData.signings]);
                dispatch(setSigningData(signingsData.signings));
            }
            if (signingsData.riders && signingsData.riders.length && insuranceCompanyList.length > 0) {
                const newConf = pagerConf;
                newConf.totalItems = signingsData.counter;
                setPagerConf(newConf);
                setSigningRiderList([...signingsData.riders]);
                dispatch(setSigningRidersData(signingsData.riders));
            }
        }
        saveScreenMode(filter);

        setLoading(false);
    }


    const getSignings = async (filter?: any) => {
        console.log('signingFilter', filter)


        setLoading(true);
        setSigningList([]);
        if (!filter) {
            filter = signingFilter;
        }
        if (sortBy && !filter.sortBy) {
            filter.sortBy = [sortBy];
        }

        const filterKeys = Object.keys(filter);
        const filterParams: any[] = [];


        filterKeys.forEach((key: string) => {
            if (filter[key] == undefined && key !== 'ElementaryPolicyStatusId') return;
            const filterOption: any = {
                key: key,
                label: ''
            }
            let include = false;
            switch (key) {
                case 'openPolicies': {
                    if (filter[key]) {
                        filterOption.label = 'סטטוס';
                        const selected = creatorsList.find((a: any) => a.value == filter.creatorUserId);
                        filterOption.value = "כל הפתוחים";
                        include = true;
                    }
                    break;
                }
                case 'creatorUserId': {
                    filterOption.label = 'נוצר ע"י';
                    const selected = creatorsList.find((a: any) => a.value == filter.creatorUserId);
                    if (selected) {
                        filterOption.value = selected.label;
                    }
                    include = true;
                    break;
                }
                case 'productionType': {
                    filterOption.label = 'סוג הפקה';
                    const selected = productionTypes.find((a: any) => a.value == filter.productionType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'leadSource': {
                    filterOption.label = 'סוג הפקה';
                    const options = [
                        {
                            label: 'חדש',
                            value: '0'
                        },
                        {
                            label: 'חידוש',
                            value: '1'
                        }
                    ];
                    const selected = options.find((o: any) => o.value == filter.leadSource);
                    if (selected) {
                        include = true;
                        filterOption.value = selected.label;
                    }
                    break;
                }
                case 'ElementaryPolicyStatusId': {
                    filterOption.label = 'סטטוס';
                    const selected: any = policyStatuses.find((ps: any) => ps.value == filter.ElementaryPolicyStatusId);
                    if (selected) {
                        include = true;
                        filterOption.value = selected.label;
                    }
                    break;
                }
                case 'underwriterUserId': {
                    filterOption.label = 'מטפל';
                    const selected = creatorsList.find((a: any) => a.value == filter.underwriterUserId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'insuranceCompanyId': {
                    filterOption.label = 'חברת ביטוח';
                    if (filter.insuranceCompanyId === '-1') {
                        filterOption.value = 'פלוס שירותי דרך';
                        include = true;
                    } else {
                        const selected = insuranceCompanyList.find((a: any) => a.value == filter.insuranceCompanyId);
                        if (selected) {
                            filterOption.value = selected.label;
                            include = true;
                        }
                    }
                    break;
                }
                case 'insuranceCompanyRouteId':
                    filterOption.label = 'מסלול';
                    filterOption.value = filter.insuranceCompanyRouteLabel;
                    include = true;
                    break;
                case 'agentId': {
                    filterOption.label = 'סוכן';
                    const selected = agentsList.find((a: any) => a.value == filter.agentId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'createdDateFrom': {
                    filterOption.label = 'ת. יצירה מ';
                    filterOption.value = moment(filter.createdDateFrom).format('DD-MM-YYYY');
                    include = true;
                    break;
                }
                case 'createdDateTo':
                    filterOption.label = 'ת. יצירה עד';
                    filterOption.value = moment(filter.createdDateTo).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'startDateFrom':
                    filterOption.label = 'יעד סיום מ';
                    filterOption.value = moment(filter.startDateFrom).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'startDateTo':
                    filterOption.label = 'יעד סיום עד';
                    filterOption.value = moment(filter.startDateTo).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'policyType': {
                    filterOption.label = 'סוג הפוליסה';
                    const selected = policyTypes.find((a: any) => a.value == filter.policyType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'insuranceType': {
                    filterOption.label = 'סוג הביטוח';
                    const selected = insuranceTypes.find((a: any) => a.value == filter.insuranceType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                // case 'productionStep':
                //     filterOption.label = 'הפקה';
                //     include = filterOption.value = filter.productionStep;
                //     break;
                case 'collectionStep':
                    filterOption.label = 'גביה';
                    if (filter.collectionStep != null && filter.collectionStep != undefined) {
                        filterOption.value = filter.collectionStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'protectionStep':
                    filterOption.label = 'מיגון';
                    if (filter.protectionStep != null && filter.protectionStep != undefined) {
                        filterOption.value = filter.protectionStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'lackOfClaimsStep':
                    filterOption.label = 'ה. תביעות';
                    if (filter.lackOfClaimsStep != null && filter.lackOfClaimsStep != undefined) {
                        filterOption.value = filter.lackOfClaimsStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'documentsStep':
                    filterOption.label = 'מסמכים';
                    if (filter.documentsStep != null && filter.documentsStep != undefined) {
                        filterOption.value = filter.documentsStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'sendingToCustomerStep':
                    filterOption.label = 'שליחה';
                    if (filter.sendingToCustomerStep != null && filter.sendingToCustomerStep != undefined) {
                        filterOption.value = filter.sendingToCustomerStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;


                default:
                    break;
            }

            if (include && filterOption.value !== undefined) {
                filterParams.push(filterOption)
            }
            console.log('filterParams', key, filter[key], filterParams);
        });
        setSelectedFilterOptions(filterParams)
        setFilterCount(filterParams.length.toString());

        // setShowOnlyRiders(false);
        if (filter.insuranceCompanyId < 0) {
            filter.insuranceCompanyId = undefined;
            setShowOnlyRiders(true);
        } else {
            setShowOnlyRiders(false);
        }

        if (filter.openPolicies) {
            setShowOnlyOpens(true);
        }
        else {
            setShowOnlyOpens(false);
        }
        setSigningList([]);
        setSigningRiderList([]);
        const signingsData = await signingModel.signingFilter(filter);
        if (signingsData) {
            if (signingsData.signings && signingsData.signings.length && insuranceCompanyList.length > 0) {
                const newConf = pagerConf;
                newConf.totalItems = signingsData.counter;
                setPagerConf(newConf);
                setSigningList([...signingsData.signings]);
            }
            if (signingsData.riders && signingsData.riders.length && insuranceCompanyList.length > 0) {
                const newConf = pagerConf;
                newConf.totalItems = signingsData.counter;
                setPagerConf(newConf);
                setSigningRiderList([...signingsData.riders]);
            }
            dispatch(setSigningData(signingsData.signings));
            dispatch(setSigningRidersData(signingsData.riders));
        }
        saveScreenMode(filter);

        setLoading(false);
    }

    const getSilentSignings = async (filter?: any) => {
        //setLoading(true);
        setSigningList([]);
        if (!filter) {
            filter = signingFilter;
        }
        if (sortBy && !filter.sortBy) {
            filter.sortBy = [sortBy];
        }

        const filterKeys = Object.keys(filter);
        const filterParams: any[] = [];

        filterKeys.forEach((key: string) => {

            if (filter[key] == undefined) return;
            const filterOption: any = {
                key: key,
                label: ''
            }
            let include = false;
            switch (key) {
                case 'creatorUserId': {
                    filterOption.label = 'נוצר ע"י';
                    const selected = creatorsList.find((a: any) => a.value == filter.creatorUserId);
                    if (selected) {
                        filterOption.value = selected.label;
                    }
                    include = true;
                    break;
                }
                case 'productionType': {
                    filterOption.label = 'סוג הפקה';
                    const selected = productionTypes.find((a: any) => a.value == filter.productionType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'leadSource': {
                    filterOption.label = 'סוג הפקה';
                    const options = [
                        {
                            label: 'חדש',
                            value: '0'
                        },
                        {
                            label: 'חידוש',
                            value: '1'
                        }
                    ];
                    const selected = options.find((o: any) => o.value == filter.leadSource);
                    if (selected) {
                        include = true;
                        filterOption.value = selected.label;
                    }
                    break;
                }
                case 'ElementaryPolicyStatusId': {
                    filterOption.label = 'סטטוס';
                    const selected: any = policyStatuses.find((ps: any) => ps.value == filter.ElementaryPolicyStatusId);
                    if (selected) {
                        include = true;
                        filterOption.value = selected.label;
                    }
                    break;
                }
                case 'underwriterUserId': {
                    filterOption.label = 'מטפל';
                    const selected = creatorsList.find((a: any) => a.value == filter.underwriterUserId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'insuranceCompanyId': {
                    filterOption.label = 'חברת ביטוח';
                    if (filter.insuranceCompanyId === '-1') {
                        filterOption.value = 'פלוס שירותי דרך';
                        include = true;
                    } else {
                        const selected = insuranceCompanyList.find((a: any) => a.value == filter.insuranceCompanyId);
                        if (selected) {
                            filterOption.value = selected.label;
                            include = true;
                        }
                    }
                    break;
                }
                case 'insuranceCompanyRouteId':
                    filterOption.label = 'מסלול';
                    filterOption.value = filter.insuranceCompanyRouteLabel;
                    include = true;
                    break;
                case 'agentId': {
                    filterOption.label = 'סוכן';
                    const selected = agentsList.find((a: any) => a.value == filter.agentId);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'createdDateFrom': {
                    filterOption.label = 'ת. יצירה מ';
                    filterOption.value = moment(filter.createdDateFrom).format('DD-MM-YYYY');
                    include = true;
                    break;
                }
                case 'createdDateTo':
                    filterOption.label = 'ת. יצירה עד';
                    filterOption.value = moment(filter.createdDateTo).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'startDateFrom':
                    filterOption.label = 'יעד סיום מ';
                    filterOption.value = moment(filter.startDateFrom).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'startDateTo':
                    filterOption.label = 'יעד סיום עד';
                    filterOption.value = moment(filter.startDateTo).format('DD-MM-YYYY');
                    include = true;
                    break;
                case 'policyType': {
                    filterOption.label = 'סוג הפוליסה';
                    const selected = policyTypes.find((a: any) => a.value == filter.policyType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                case 'insuranceType': {
                    filterOption.label = 'סוג הביטוח';
                    const selected = insuranceTypes.find((a: any) => a.value == filter.insuranceType);
                    if (selected) {
                        filterOption.value = selected.label;
                        include = true;
                    }
                    break;
                }
                // case 'productionStep':
                //     filterOption.label = 'הפקה';
                //     include = filterOption.value = filter.productionStep;
                //     break;
                // case 'collectionStep':
                //     filterOption.label = 'גביה';
                //     include = filterOption.value = filter.collectionStep;
                //     break;
                // case 'protectionStep':
                //     filterOption.label = 'מיגון';
                //     include = filterOption.value = filter.protectionStep;
                //     break;
                // case 'lackOfClaimsStep':
                //     filterOption.label = 'ה. תביעות';
                //     include = filterOption.value = filter.lackOfClaimsStep;
                //     break;
                // case 'documentsStep':
                //     filterOption.label = 'מסמכים';
                //     include = filterOption.value = filter.documentsStep;
                //     break;
                // case 'sendingToCustomerStep':
                //     filterOption.label = 'שליחה';
                //     include = filterOption.value = filter.sendingToCustomerStep;
                //     break;

                case 'collectionStep':
                    filterOption.label = 'גביה';
                    if (filter.collectionStep != null && filter.collectionStep != undefined) {
                        filterOption.value = filter.collectionStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'protectionStep':
                    filterOption.label = 'מיגון';
                    if (filter.protectionStep != null && filter.protectionStep != undefined) {
                        filterOption.value = filter.protectionStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'lackOfClaimsStep':
                    filterOption.label = 'ה. תביעות';
                    if (filter.lackOfClaimsStep != null && filter.lackOfClaimsStep != undefined) {
                        filterOption.value = filter.lackOfClaimsStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'documentsStep':
                    filterOption.label = 'מסמכים';
                    if (filter.documentsStep != null && filter.documentsStep != undefined) {
                        filterOption.value = filter.documentsStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                case 'sendingToCustomerStep':
                    filterOption.label = 'שליחה';
                    if (filter.sendingToCustomerStep != null && filter.sendingToCustomerStep != undefined) {
                        filterOption.value = filter.sendingToCustomerStep ? "עם" : "בלי";
                        include = true;
                    }
                    else {
                        include = false;
                    }
                    break;
                default:
                    break;
            }

            if (include && filterOption.value !== undefined) {
                filterParams.push(filterOption)
            }
            console.log('filterParams', key, filter[key], filterParams);
        });
        setSelectedFilterOptions(filterParams)
        setFilterCount(filterParams.length.toString());

        // setShowOnlyRiders(false);
        if (filter.insuranceCompanyId < 0) {
            filter.insuranceCompanyId = undefined;
            setShowOnlyRiders(true);
        } else {
            setShowOnlyRiders(false);
        }
        if (filter.openPolicies) {
            setShowOnlyOpens(true);
        }
        else {
            setShowOnlyOpens(false);
        }
        const signingsData = await signingModel.signingFilter(filter);
        if (signingsData) {
            console.log('signingList useEffect', signingsData);
            if (signingsData.signings && signingsData.signings.length && insuranceCompanyList.length > 0) {

                const newConf = pagerConf;
                newConf.totalItems = signingsData.counter;
                setPagerConf(newConf);

                // const company = insuranceCompanyList.find()
                console.log('signingList signingsData', signingsData);
                signingsData.signings.forEach((s: any) => {

                });

            }

        }


        saveScreenMode(filter);
        //setLoading(false);
    }

    const buildOptionsForSelect = (source: any[], param: string = 'id', label: string = 'הכל') => {
        const items: any[] = [];
        source.forEach((i: any) => {
            items.push(
                {
                    label: i.fullName,
                    value: i[param]
                }
            );
        })
        console.log('buildOptionsForSelect', items);
        return items;
    }

    const onPageChange = async (page: number) => {
        if (page === 0) {
            page = 1;
        }
        const newConf = pagerConf;
        newConf.currentPage = page;
        setCurrentPage(page);
        setPagerConf(newConf);
        console.log('onPageChange', page);
        const newFilter = signingFilter;
        newFilter.page = page;
        await setSigningFilter(newFilter);
        getSignings(newFilter);
        // getTreatments(newFilter);
    }


    const handleTreatmentSearchChange = async (event: any) => {
        const newSearchText = event.target.value;
        setSearchText(newSearchText);
        const newFilter = signingFilter;
        newFilter.searchTerm = newSearchText;
        setSigningFilter(newFilter);

        clearTimeout(treatmentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            // getTreatments(newFilter);
        }, 1000);
        setTreatmentsTimeoutId(newTimeoutId);
    };

    const onShowDocumentPopUp = (url: string) => {
        setDocumentUrl(url);
    }

    const onHideDocumentPopUp = () => {
        setDocumentUrl(null);
    }

    const doFilter = (filter?: any) => {
        dispatch(setSigningData([]));
        dispatch(setSigningRidersData([]));

        let newFilter = filter ? filter : signingFilter;
        getSignings(newFilter);
    }

    const clearTreatmentsFliter = () => {
        dispatch(setSigningData([]));
        dispatch(setSigningRidersData([]));

        sessionStorage.removeItem('signingPageData');
        const newFilter: any = {
            page: 1,
            searchTerm: undefined,
            userId: undefined,
            createdById: undefined,
            insuranceCompanyRouteId: undefined,
            insuranceCompanyRouteLabel: undefined,
        };
        setSelectedDateParam('0')
        setSearchText('');
        setSelectedInsuranceCompany('');
        setSelectedAgent('0');
        setSigningFilter(newFilter);
        getSignings(newFilter);
    }

    // signing function end

    const showAndHideAddTreatmentPopup = (show: boolean) => {
        setShowAddTreatmentPopup(show);
    }

    const showHideAddSubscriberPopup = (show: boolean) => {
        setShowAddSubscriberPopup(show);
    }

    const onAddTreatment = async (customerId: string, policyId: string, type: number) => {
        if (type == TreatmentType._4) {
            var assigment = await customerCardModel.treatmentsForUpsert({ "customerId": customerId, "policyId": policyId, "TreatmentType": type })
            setSelectedAssigment(assigment);
            setTreatmentType(type);
            setPolicyId(policyId);
            setCustomerId(customerId);
        }
    }
    ///////////

    const onNewOrEditTreatment = (customerId: string, policyId: string, type: number) => {
        console.log('onNewOrEditTreatment', customerId, policyId, type);
        setTreatmentType(type);
        setCustomerId(customerId);
        setShowAddTreatmentPopup(true);
        setPolicyId(policyId);
    }
    /////////

    const onAddSubscriber = (customer: any, vehicle: any) => {
        if (customer) {
            if (customer.createdDate && typeof (customer.createdDate) === 'string') {
                customer.createdDate = moment(customer.createdDate);
            }
            if (customer.updatedDate && typeof (customer.updatedDate) === 'string') {
                customer.updatedDate = moment(customer.updatedDate);
            }
            if (customer.driverLicensIssueDate && typeof (customer.driverLicensIssueDate) === 'string') {
                customer.driverLicensIssueDate = moment(customer.driverLicensIssueDate);
            }
            if (customer.identityIssueDate && typeof (customer.identityIssueDate) === 'string') {
                customer.identityIssueDate = moment(customer.identityIssueDate);
            }
            // identityIssueDate
            // driverLicensIssueDate
            // updatedDate
        }
        console.log('onAddSubscriber', customer);
        setSelectedCustomer(customer);
        setSelectedVehicle(vehicle);
        showHideAddSubscriberPopup(true);

    }

    const onSortChange = async (property: string) => {
        let currentSort: any = sortBy ? { ...sortBy } : {
            property: "createdDate",
            SortDirection: ""
        };

        const filter = signingFilter;
        if (currentSort.property == property && sortBy && sortBy.SortDirection == 'DESC') {
            await setSortBy(undefined);
            filter.sortBy = undefined;
        } else {
            if (currentSort.property == property && sortBy) {
                currentSort.SortDirection = sortBy.SortDirection == 'ASC' ? 'DESC' : 'ASC'
            } else {
                currentSort.SortDirection = 'ASC';
                currentSort.property = property;
            }
            await setSortBy(currentSort);
            filter.sortBy = [currentSort];
        }
        // getTreatments(filter);
    }

    const onSaveTask = async (data: any) => {
        if (data.endDate) {
            if (typeof (data.endDate) !== 'object') {
                data.endDate = new Date(data.endDate);
            }
        }

        const d = await customerCardModel.upsertAssignment(data);
        showAndHideAddTreatmentPopup(false);
        if (sellectedSigningId && signingList) {
            const selectedItem = signingList.find((si: any) => si.id == sellectedSigningId);
            const commentyData = {
                "TreatmentType": 4,
                "AlertDate": moment().format('YYYY-MM-DDTHH:mm'),
                "Topic": "משימת חיתום  הוקמה",
                "PolicyRelatedId": policyId,
                'Seen': true

            }
            addSigningComment(commentyData, sellectedSigningId);
        }
        var l = loadTreatments;
        l++;
        setLoadTreatments(l)
    }

    const onExportToExcel = async () => {
        const filter = signingFilter;
        let model = await signingModel.signingExportToExcel(filter);

        console.log('exportFile', model)
        console.log('export')

    }

    const closeTab = (id: string, e?: Event) => {
        if (e) {
            e.preventDefault();
        }
        const currentTabs = openTabs.filter((m: any) => m.id !== id);
        updateOpenTabs(currentTabs);
        if (sellectedSigningId == id) {
            setSellectedSigningId(null);
            setSelectedTabData(null);
        }
    }

    const updateOpenTabs = async (tabs: any) => {
        await setOpenTabs(tabs);
        const tabsForSave: any[] = [];
        tabs.forEach((tab: any) => {
            const tContent: any = {
                type: tab.type,
                title: tab.title,
                id: tab.id,
                mode: tab.mode,
                editData: tab.editData ? tab.editData : undefined,
                loaded: false
            }
            if (tab.editData && typeof tab.editData !== 'undefined') {
                tContent.editData = tab.editData;
            }
            tabsForSave.push(tContent);
        });
        // localStorage.setItem('clientsOpenTabs', JSON.stringify(tabsForSave));
    }

    const showSigningTab = (id: string) => {
        if (id == sellectedSigningId) {
            return;
        }
        showSigning(id);
    }

    const showSigningSList = () => {
        setSellectedSigningId(null);
    }

    const showSigning = async (id: string, mode: ViewMode = ViewMode.VIEW) => {
        await setSellectedSigningId(null);
        await setSelectedTabData(null);
        let tabContent = openTabs.find((m: any) => m.id == id);
        let viewMode: ViewMode = mode;
        if (tabContent) {
            viewMode = tabContent.mode;
        }

        if (!tabContent || (tabContent.mode != ViewMode.ADD && !tabContent.loaded)) {
            const tabIsExists = tabContent ? true : false;
            setLoading(true);
            if (signingList) {
                const selectedItem = signingList.find((si: any) => si.id == id);
                console.log('showSigning-selectedItem', selectedItem)

                if (selectedItem) {
                    tabContent = {
                        type: 'editSigning',
                        id: id,
                        title: selectedItem.fullName ? selectedItem.fullName : 'ללא שם',
                        loaded: true,
                        signingData: selectedItem,
                        genders: gendersList,
                        statuses: policyStatuses,
                        vehicleOwnerships: vehicleOwnerships
                    }
                    openTabs.push(tabContent);
                    updateOpenTabs(openTabs);
                }
            }
            setLoading(false);
        }
        setSellectedSigningId(id);
        setSelectedTabData(tabContent);
    }

    const toggleShowAdvancedSearch = (newValue?: boolean) => {
        if (!newValue) {
            newValue = showAdvancedSearch;
            setShowAdvancedSearch(!newValue)
        } else {
            setShowAdvancedSearch(newValue)
        }
    }

    const onAdvancedSearchApprove = (newFilter: any) => {
        console.log('onAdvancedSearchApprove-newFilter', newFilter)

        setSigningFilter(newFilter);

        setTimeout(async () => {
            await getSignings(JSON.parse(JSON.stringify(newFilter)));
            toggleShowAdvancedSearch(false);
        }, 100);
    }

    const onAdvancedSearchClear = () => {
        clearTreatmentsFliter();
        toggleShowAdvancedSearch(false);
    }

    const onAssignToHandlerClick = (id: string) => {
        setSigningIdToAssign(id);
        setShowAssignToHandlerPopUp(true);
    }

    const onAssignToHandlerApprove = async (handlerId: string) => {
        console.log('handlerId', handlerId);
        if (handlerId && signingList && signingIdToAssign) {
            const signingForUpdate = signingList.find((s: any) => s.id == signingIdToAssign);
            if (signingForUpdate) {
                const updatedSigning = { ...signingForUpdate, signingUserId: handlerId };
                await elementaryPolicyStatusModel.signingUpdate(updatedSigning);
                console.log('onSigningUpdate', updatedSigning);
                getSignings();
            }
        }
        setShowAssignToHandlerPopUp(false);
    }

    const onSigningUpdate = async (newData: any, index?: number) => {
        // saveDataProduction
        // newData.offer = null;
        let res = await elementaryPolicyStatusModel.signingUpdate(newData);
        if (res && res.status == 200) {
            // Set pop up message success
            setPopUpTitle('העדכון בוצע בהצלחה');
            setShowPopUpMessage(true);
            // Refresh list data
            getSignings();
        }
        console.log('onSigningUpdate', newData)
    }

    const onSigningUpdate2 = async (newData: any, index?: number) => {
        // saveDataProduction
        // newData.offer = null;
        let res = await elementaryPolicyStatusModel.signingUpdate2(newData);
        if (res && res.status == 200) {
            // Set pop up message success
            setPopUpTitle('העדכון בוצע בהצלחה');
            setShowPopUpMessage(true);
            // Refresh list data
            getSignings();
        }
        console.log('onSigningUpdate2', newData)
    }

    const addSigningComment = async (commentData: any, signingId: string) => {
        const newTreatment = await elementaryPolicyStatusModel.sendSigningComment(commentData);
        if (signingId && signingList) {
            const fIndex = signingList.findIndex((s: any) => s.id === signingId);
            // signingList[fIndex].treatments.push()
        }
    }

    const setSigningSeen = async (signingId: string) => {
        setTimeout(() => {
            getSilentSignings();
        }, 1000);
    }

    const onSigningDelete = async (id: string) => {
        await signingModel.signingDelete(id);
        getSignings();
    }

    const onPolicyUpdate = async (newData: any) => {
        newData.offer = null;
        await offerProductionModel.saveDataProduction(newData);
    }

    const onPolicyFileDelete = async (fileId: string) => {
        await offerProductionModel.deleteFile(fileId);
    }

    const onRemoveFilterOption = (key: string) => {
        const newList = selectedFilterOptions.filter((i: any) => i.key !== key);
        setSelectedFilterOptions(newList);
        const newFilter = signingFilter;
        newFilter[key] = undefined;
        if (key == 'insuranceCompanyRouteId') {
            newFilter.insuranceCompanyRouteLabel = undefined;
        }
        if (key == 'underwriterUserId') {
            newFilter.underwriterType = undefined;
        }
        if (key == 'creatorUserId') {
            newFilter.createdBy = undefined;
        }
        setSigningFilter(newFilter);
        doFilter(newFilter);
    }

    const hideSigningConfigPopup = () => {
        setShowSigningConfigPopup(false)
    }
    const emptyFunc = (t?: any, v?: any) => { }

    const closeRiderPopup = () => {
        setRiderToEdit(null);
    }

    const closePaymentPopup = () => {
        setRiderToPayment(null);
    }

    const setCheckboxRiderStateData = async (e: any, index: number) => {
        const checked = e.target.checked;
        const newStatus = checked ? 0 : 1;
        console.log('newList[index]-checked', checked)
        let signId = ''
        if (signingRiderList && signingRiderList.length > 0) {
            const newList = signingRiderList.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        riderStatusType: newStatus,  // new object, not mutation
                    }
                    : item
            );
            signId = newList[index].id;
            setSigningRiderList(newList);
        } else if (signingList && signingList.length > 0) {
            const newList = signingList.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        rider: {
                            ...item.rider,
                            riderStatusType: newStatus, // new rider object
                        },
                    }
                    : item
            );
            signId = newList[index].rider.id;
            setSigningList(newList);
        }
        if (!signId) return;

        const res = await signingModel.riderUpdateStatus({
            "id": signId,
            "riderStatusType": checked ? 0 : 1
        });
        if (res && res.responseCode == 200) {
            console.log('riderUpdateStatus', res);
            getSignings();
        }
    }

    useEffect(() => {
        init()
    }, [])


    // useEffect(() => {
    //     const savedLoggedUser = localStorage.getItem('loggedUser');
    //     let loggedUser: any = {}
    //     if (savedLoggedUser) {
    //         loggedUser = JSON.parse(savedLoggedUser);
    //         // console.log('loggedUser', loggedUser)
    //         setCurrentUser(loggedUser);
    //         console.log('userLogged', loggedUser, userLogged)
    //     }
    // }, [userLogged])

    useEffect(() => {
        if (insuranceCompanyList && insuranceCompanyList.length > 0) {
            const signingPageData = sessionStorage.getItem('signingPageData');
            if (signingPageData) {
                const pageData = JSON.parse(signingPageData);
                if (pageData.signingFilter) {
                    console.log('useEffect', pageData.signingFilter)
                    setSigningFilter(pageData.signingFilter);
                    getSigningsInitilaize(pageData.signingFilter);
                } else {
                    getSignings();
                }
            } else {
                getSignings();
            }
        }
        setLoadData(false);
    }, [loadData])

    const setHideHandlerTreatmentPopUp = () => {
        dispatch(setHandlerTreatmentPopUp({
            show: false,
            treatmentData: null
        }));
    }

    return (
        <div className="main-content clients-main-content rtl">
            {
                loading && (
                    <PleaseWaitLayer />
                )
            }
            {riderToEdit != null ? (
                <>
                    <SubscriberPopupForSigning
                        id={riderToEdit.id}
                        actionType={undefined}
                        rider={null}
                        ClosePopup={() => closeRiderPopup()}
                        OpenPayment={goToPayment}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}
                        renewRider={false}

                    />
                </>
            ) : ""}
            {riderToPayment != null ? (
                <>
                    <SubscriberUpdatePaymentPopup
                        id={riderToPayment.id}
                        actionType={undefined}
                        rider={riderToPayment}
                        ClosePopup={() => closePaymentPopup()}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}
                        setMessageType={setMessageType}

                    />
                </>
            ) : ""}
            {
                documentUrl && (
                    <LeadDocumentPopup
                        ClosePopup={onHideDocumentPopUp}
                        documentUrl={documentUrl}
                    />
                )
            }
            {
                showSigningConfigPopUp &&
                <SigningConfigPopup
                    ClosePopup={hideSigningConfigPopup}
                    config={{}}
                    messageTitle={'הגדרות'}
                />
            }
            {/* {
                showAddTreatmentPopUp && selectedAssigment &&
                <TasksAddTaskPopup
                    ShowHidePopup={showAndHideAddTreatmentPopup}
                    type={1}
                    dataToEdit={selectedAssigment}
                    statuses={assigmentStatuses}
                    onSave={onSaveTask}
                    usersList={usersList}
                    ClosePopup={() => showAndHideAddTreatmentPopup(false)}
                />
            } */}

            {
                showAddTreatmentPopUp &&
                <ClientAddTreatmentPopup
                    ShowHidePopup={showAndHideAddTreatmentPopup}
                    ClosePopup={() => setShowAddTreatmentPopup(false)}
                    type={treatmentType}
                    customerId={customerId}
                />
            }
            {showAddSubscriberPopUp && (
                <>
                    <SubscriberPopup
                        id={''}
                        customer={selectedCustomer}
                        vehicle={selectedVehicle}
                        actionType={undefined}
                        rider={selectedTabData.signingData.rider ? selectedTabData.signingData.rider : undefined}
                        ClosePopup={() => showHideAddSubscriberPopup(false)}
                        OpenPayment={() => showHideAddSubscriberPopup(false)}
                    />
                </>
            )
            }
            {showAssignToHandlerPopUp &&
                <AssignToHandlerPopUp messageTitle="שייך לחתם" ClosePopup={() => setShowAssignToHandlerPopUp(false)} onChange={onAssignToHandlerApprove} signingId={''} />
            }

            {
                showPopUpMessage &&
                <SignMessagePopUp
                    messageTitle={popUpTitle}
                    messageContent={""}
                    ShowHidePopup={(status: boolean) => setShowPopUpMessage(status)}
                    ClosePopup={() => setShowPopUpMessage(false)}
                />
            }

            {handlerTreatmentPopUp.show ?
                <EditHandlerTreatment
                    onClose={() => setHideHandlerTreatmentPopUp()}
                    show={handlerTreatmentPopUp.show}
                    treatment={handlerTreatmentPopUp.treatmentData}
                />
                : <></>
            }


            <Menu activePage='Signing' />
            <div className="center-content">
                <Header PageName="חיתומים" />
                <section className="page-tab-row">
                    <div className="emails-tab-row">
                        <div className={`email-tab email-tab-clients selected`} onClick={emptyFunc}>
                            <div className="top-border"></div>
                            <div className="tab-content">
                                <div className="label" onClick={showSigningSList}>
                                    חיתומים
                                </div>
                            </div>
                        </div>
                        {openTabs.map((m: any) => {
                            return (
                                <div className={`email-tab email-tab-view-message email-tab-${m.id} ${sellectedSigningId == m.id ? 'selected' : ''}`} key={m.id}>
                                    <div className="top-border"></div>
                                    <div className="tab-content">
                                        <div className="label" onClick={() => showSigningTab(m.id)}>
                                            <b>{m.title}</b>
                                        </div>
                                        {/* <div className="icon-holder pointer">
                                            <div className="icon x-close-grey" onClick={(e: any) => closeTab(m.id, e)}></div>
                                        </div> */}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </section>
                <section className={`page-tab-content all-clients ${sellectedSigningId == null ? 'selected' : ''}`} id="all-clients">
                    <div className="content-header">
                        <div className="flex-end desktop-only clients-search-row client-list-search client-list-view">
                            <div className="list-actions-row flex-centered flex-space-between">
                                <div className="filter-row flex-centered client-search">
                                    <div>
                                        <div className="filter-input search">
                                            <input type="text" value={searchText} placeholder="חיפוש" onChange={handleTreatmentSearchChange}
                                                onKeyDown={(e: any) => { if (e.key === 'Enter') { doFilter(); } }} />

                                        </div>
                                    </div>
                                    <div className="filter-button">
                                        <Popover
                                            placement="bottom"
                                            content={<AdvancedSigningSearch
                                                filter={signingFilter}
                                                policyTypes={policyTypes}
                                                productionTypes={productionTypes}
                                                onHide={() => toggleShowAdvancedSearch(false)}
                                                onApprove={onAdvancedSearchApprove} onClear={onAdvancedSearchClear} />}
                                            title=""
                                            trigger="click"
                                            open={showAdvancedSearch}
                                            onOpenChange={toggleShowAdvancedSearch}
                                        >
                                            <button className="act-btn has-icon" onClick={(e: any) => emptyFunc()}>
                                                <div className="icon sliders"></div>
                                                מסננים - {filterCount}
                                            </button>
                                        </Popover>
                                    </div>
                                    <div className='flex-start flex-centered filter-option-list'>
                                        {selectedFilterOptions && selectedFilterOptions.map((fo: any, index: number) => {
                                            return <div className='filter-selected-option' key={index}>
                                                <div className='option'>
                                                    <div className='label'>{fo.label}:</div> {fo.value === true ? <FontAwesomeIcon icon={faCheck} /> : <div className='value'>{fo.value}</div>}</div>
                                                <div className="icon-holder pointer" onClick={() => onRemoveFilterOption(fo.key)}>
                                                    <div className="icon x-close-grey"></div>
                                                </div>
                                            </div>
                                        })}
                                    </div>

                                    <div className="filter-button">
                                        <button className="act-btn" onClick={() => doFilter()}>הצג דוח</button>
                                    </div>
                                    <div className="filter-button">
                                        <button className="act-btn" onClick={clearTreatmentsFliter}>נקה בחירה</button>
                                    </div>
                                    {/* <div>
                                        <div className="filter-button">
                                            <button className="act-btn" onClick={emptyFunc}>הדפס דוח</button>
                                        </div>
                                        <div className="filter-button">
                                            <button className="act-btn" onClick={emptyFunc}>יצוא לאקסל</button>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="cliets-main-buttons">

                                    <div className="icon print pointer"></div>
                                    <div className="icon excel pointer" onClick={() => onExportToExcel()}></div>

                                    {/* <button type="button" className="button blue has-icon flex-centered flex-justify-center" onClick={()=>emptyFunc()}>
                                        <div className="icon add"></div>
                                        הוסף
                                    </button> */}
                                    <div className="icon icon-config gear pointer" onClick={() => setShowSigningConfigPopup(true)}></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <SigningTable
                        signingList={signingList ? signingList : []}
                        signingRiderList={signingRiderList ? signingRiderList : []}
                        statuses={policyStatuses ? policyStatuses : []}
                        sortBy={sortBy}
                        className='big'
                        showOnlyRiders={showOnlyRiders}
                        showOnlyOpens={showOnlyOpens}
                        setRiderToPopup={setRiderToPopup}
                        onUpdatePaymentsClick={onUpdatePaymentsClick}
                        onActivateRiderClick={onActivateRiderClick}
                        setSigningSeen={(signingId: string) => setSigningSeen(signingId)}
                        onNewOrEditTreatment={(customerId: string, policyId: string, type: number) => onNewOrEditTreatment(customerId, policyId, type)}
                        actionBtns={isActionBtns}
                        actions={{
                            edit: (id: string) => emptyFunc(),
                            assignToHandler: (id: string) => onAssignToHandlerClick(id),
                            update: (data: any, index?: number) => onSigningUpdate(data, index),
                            sendEmail: (id: string) => emptyFunc(),
                            sendWhatsApp: (id: string) => emptyFunc(),
                            print: (id: string) => emptyFunc(),
                            setStatus: (id: string, newStatus: string) => emptyFunc(),
                            delete: (id: string) => onSigningDelete(id),
                            onSortChange: (property: string) => onSortChange(property),
                            onShowDocument: (url: string) => onShowDocumentPopUp(url),
                            onSelectSigning: (id: string) => showSigningTab(id),
                            addSigningComment: (commentData: any, signingId: string) => addSigningComment(commentData, signingId),
                            setCheckboxRider: (e: any, index: number) => setCheckboxRiderStateData(e, index),
                        }}
                    />

                    <footer className="footer emails-list-footer emails-list-view">
                        <Pagger pagerConf={pagerConf} changePage={onPageChange} refresh={emptyFunc}></Pagger>
                    </footer>
                </section>
                {!loading && sellectedSigningId != null && sellectedSigningId.length > 0 ? (
                    <section className={`page-tab-content ${sellectedSigningId != null ? 'selected' : ''}`}>
                        <SigningDetails
                            actionBtns={isActionBtns}
                            onAddTreatment={(customerId: string, policyId: string, type: number) => onAddTreatment(customerId, policyId, type)}
                            onAddSubscriber={(customer: any, vehicle: any) => onAddSubscriber(customer, vehicle)}
                            customerId={sellectedSigningId}
                            tabData={selectedTabData}
                            setLoading={setLoading}
                            updateEditData={(data: any, index?: number) => onSigningUpdate2(data, index)}
                            updatePolicy={(data: any) => onPolicyUpdate(data)}
                            addSigningComment={(commentData: any) => addSigningComment(commentData, sellectedSigningId)}
                            onFileDelete={(fileId: string) => onPolicyFileDelete(fileId)}
                            updateMode={emptyFunc}
                            TreatmentPolicy={policyId}
                            TreatmentPop={showAddTreatmentPopUp}
                            config={{
                            }}
                            loadTreatments={loadTreatments}
                            closeTab={closeTab}
                            onNewOrEditTreatment={(customerId: string, policyId: string, type: number) => onNewOrEditTreatment(customerId, policyId, type)}
                            statuses={policyStatuses ? policyStatuses : []}
                        />
                    </section>
                ) : (
                    <></>
                )
                }


            </div>
        </div>
    )
}
export default Signing;